// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Person } from "../../../data/app-core/person";
import { Resource } from "../../../data/talent-core/resource";
import { ResourceResourceType } from "../../../data/talent-core/resource-resource-type";
import { ResourceCitizenship } from "../../../data/talent-core/resource-citizenship";
import { Engagement } from "../../../data/talent-core/engagement";
import { ActingProfile } from "../../../data/talent-core/acting-profile";
import { ActingProfileEthnicity } from "../../../data/talent-core/acting-profile-ethnicity";
import { ActingProfileCharacterType } from "../../../data/talent-core/acting-profile-character-type";
import { EnvelopeDocument } from "../base/envelope-document";

export class ResourceDocument extends EnvelopeDocument {
	public Person: Person = new Person();
	public override Item: Resource = new Resource();
	public ResourceTypes: ResourceResourceType[] = [];
	public Citizenships: ResourceCitizenship[] = [];
	public Engagements: Engagement[] = [];
	public ActingProfiles: ActingProfile[] = [];
	public ProfileEthnicities: ActingProfileEthnicity[] = [];
	public ProfileCharacterTypes: ActingProfileCharacterType[] = [];
}